import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const existsActiveAuctionWithPlate = async (plate, context = {}) => {
  try {
    const existsActiveAuctionFn = httpsCallable(functions, 'existsActiveAuctionWithPlateV2');
    const result = await existsActiveAuctionFn({
      plate,
      operatingUnitId: context.operatingUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
    });
    return result.data.exists;
  } catch (error) {
    console.error('Error verificando patente activa:', error);
    notifyPermissionDenied(error);
    return false;
  }
};
